import { createContext, useContext } from 'react';
import { ErrorHandlerContextType } from './types';

export const ErrorHandlerContext = createContext<ErrorHandlerContextType>(
    {} as ErrorHandlerContextType
);

export const useErrorHandler = () => useContext(ErrorHandlerContext);
